export default defineNuxtPlugin(() => {
  // // Interceptor global para $fetch
  // globalThis.$fetch = globalThis.$fetch.create({
  //   onRequest({ options }) {
  //     // Añadir la cabecera X-Client-App
  //     const headers = new Headers(options.headers as HeadersInit)
  //     headers.set('X-Client-App', 'byhours-client')
  //     options.headers = headers
  //   }
  // })
})

